export const ReceiptCheck = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 14H14M10.25 8.95L11.3 10L13.75 7.55M5 4V19.3884C5 19.7723 5.41474 20.013 5.74807 19.8225L8.03533 18.5155C8.32563 18.3496 8.67963 18.3398 8.97868 18.4893L11.5528 19.7764C11.8343 19.9172 12.1657 19.9172 12.4472 19.7764L15.0213 18.4893C15.3204 18.3398 15.6744 18.3496 15.9647 18.5155L18.2519 19.8225C18.5853 20.013 19 19.7723 19 19.3884V4C19 3.44772 18.5523 3 18 3H6C5.44772 3 5 3.44772 5 4Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ReceiptCheck
